<template>
  <div>
    <div class="surveyBoxContainer">
      <h5>
        Q{{item.order}}. {{item.question}} {{item.essential == 'Y' ? '' : '(선택)'}} 
      </h5>
      <div class="surveyBoxInput flex flexAlignS">
        * 단답형은 통계 수치를 나타낼 수 없어 엑셀 다운로드하여 확인바랍니다.
      </div>
    </div>
  </div>
</template>

<script>
import {STATUS} from '@/data/survey'

export default {
  name: 'Short',
  props:{
    status: null,
    item: null
  },
  data(){
    return{
      isOngoing: false,
    }
  },
  mounted(){
    switch(this.status){
      case STATUS.ONGOING:
        this.isOngoing = true
        break
      default:
        this.isOngoing = false
        break
    }
  }
}
</script>